import ImageItem from '@/common/interfaces/ImageItem';
import { editHtml } from '@/utils/htmlUtils';

export interface IntroRichBlockViewModel {
  Title: string;
  TextBody: string;
  Image: ImageItem;
  AlternateImageLayout?: Boolean;
}

export const convert = (data: IntroRichBlockViewModel): IntroRichBlockViewModel => {
  data.TextBody = editHtml(
    data.TextBody,
    [{ selector: 'a', fn: (a) => (a.className = 'cta cta--inline') }],
  );
  return data;
};
